import { render, staticRenderFns } from "./UpdatePaymentButton.vue?vue&type=template&id=1203ea5a&"
import script from "./UpdatePaymentButton.vue?vue&type=script&lang=ts&"
export * from "./UpdatePaymentButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports